<template>
 <a-modal
      :visible="isShow"
      class="customermodel1"
      @ok="onOk"
      @cancel="onCancel"
      width="400px"
      :centered="true"
      :footer="false"
      :closable="false"
      :maskClosable="true"
    >
      <div class="con delclasses-model">
        <div class="icte">
          <div class="icon"><img :src="imgUrl" /></div>
          <div class="text">
            <h1>{{message}}</h1>
          </div>
        </div>
        <div class="button">
          <a-button
            size="large"
            @click="onCancel"
          >取消</a-button>
          <a-button
            size="large"
            type="primary"
            @click="onOk"
          >确认</a-button>
        </div>
      </div>
</a-modal>
</template>
<script>
export default {
  inject: ['eventBus'],
  data () {
    return {
      imgUrl: '',
      message: '',
      emitData: undefined,
      isShow: false
    }
  },
  methods: {
    ShowModal (message, callbackData, imgUrl) {
      this.message = message
      this.emitData = callbackData
      this.imgUrl = imgUrl
      this.isShow = true
    },
    onOk () {
      this.$emit('onConfirm', this.emitData)
      this.isShow = false
    },
    onCancel () {
      this.isShow = false
    }
  },
  created () {
    this.eventBus.$on('show-commonconfirm-modal', this.ShowModal)
  },
  beforeDestroy () {
    this.eventBus.$off('show-commonconfirm-modal', this.ShowModal)
  }
}
</script>
